import gsap from "gsap";
import EventDispatcher from "../../common/EventDispatcher";
import { Global } from "../../common/global";
import { clickUpdator } from "../../common/api";

export default class Start {
  constructor() {
    setTimeout(() => {
      const startNowBtn = document.querySelector("#start_sec #startNowBtn");
      const playNowBtn = document.querySelector("#start_sec #playNow");
      // const leaderBtn = document.querySelector("#start_sec #leaderBtn");
      const prizeClose = document.querySelector("#start_sec .prize_close");


      
      if (!startNowBtn || !playNowBtn || !prizeClose) {
        // alert("One or more elements are missing!");
        return;
      }
     
      startNowBtn.addEventListener("click", (v) => {
        v.stopImmediatePropagation();
        // alert("Start Now Button Clicked");
        this.showPrize();
      });

      playNowBtn.addEventListener("click", () => {
        // alert("Play Now Button Clicked");
        this.playGame();
      });

      // leaderBtn.addEventListener("click", () => {
      //   // alert("Leaderboard Button Clicked");
      //   this.showLeader();
      // });

      prizeClose.addEventListener("click", () => {
        // alert("Prize Close Button Clicked");
        this.hidePrize();
      });

      // Mobile-specific event
      startNowBtn.addEventListener("touchstart", () => {
        // alert("Touch event detected!");
        this.showPrize();
      });
    }, 1000); // Delay to ensure elements are available in DOM
  }

  init() {
    this.events = EventDispatcher.getObj();
    this.events.addEventListener("GAMESCENE_EVENTS", this.onEvents.bind(this));
    this.prizeShown = false;
  }

  onEvents(data) {
    switch (data["message"]["event_type"]) {
      case "show_screen":
        this.showScreen(data["message"]["data"]);
        break;
    }
  }

  showScreen(data) {
    if (data["screenKey"] !== "Start") return false;

    document.querySelector("#start_sec").classList.add("active");
    this.showAnimation();
  }

  async showLeader() {
    // alert("Navigating to leaderboard...");
    
    const result = await clickUpdator(true, "leaderboard");

    this.hideScreen();
    Global.goBackTo = "Start";
    this.events.dispatchEvent({
      type: "GAMESCENE_EVENTS",
      message: {
        event_type: "show_screen",
        data: {
          screenKey: "Leaderboard",
        },
      },
    });
  }

  showAnimation() {
    this.frameDate = { value: 1 };
    this.lastVal = 0;
    this.introTwn = gsap.to(this.frameDate, {
      value: 32,
      duration: 4,
      ease: "none",
      repeat: -1,
      delay: .2,
      onUpdate: function () {
        if (this.lastVal != Math.floor(this.frameDate.value)) {
          document
            .querySelector("#start_sec .globe")
            .classList.remove(`globe${this.lastVal}`);
          this.lastVal = Math.floor(this.frameDate.value);
          document
            .querySelector("#start_sec .globe")
            .classList.add(`globe${this.lastVal}`);
        }
      }.bind(this),
    });
  }

  hidePrize() {
    // alert("Hiding Prize Section");
    this.prizeShown = false;
    document.querySelector("#start_sec").classList.remove("show_reward");
    document.querySelector("#start_sec #playNow").classList.remove("active");
    this.events.dispatchEvent({
      type: "GAMESCENE_EVENTS",
      message: {
        event_type: "show_menu",
        data: {
        },
      },
    });
  }

  showPrize() {
    // alert("Showing Prize Section");
    if (this.prizeShown) return false;

    this.prizeShown = true;
    setTimeout(() => {
      document.querySelector("#start_sec").classList.add("show_reward");
      document.querySelector("#start_sec #playNow").classList.add("active");
    }, 300);

    this.events.dispatchEvent({
      type: "GAMESCENE_EVENTS",
      message: {
        event_type: "hide_menu",
        data: {
        },
      },
    });
  }

  async playGame() {
    // alert("Starting Game...");
    const result = await clickUpdator(true, "playNow");
    localStorage.setItem("gameKey", result.gameKey);

    this.introTwn && this.introTwn.kill();
    this.showNextScreen();
    this.events.dispatchEvent({
      type: "GAMESCENE_EVENTS",
      message: {
        event_type: "hide_menu",
        data: {
        },
      },
    });
  }

  showNextScreen() {
    // alert("Navigating to next screen...");
    this.hideScreen();

    this.events.dispatchEvent({
      type: "SOUND_EVENTS",
      message: {
        event_type: "stop_sound",
        data: { sndKey: "music" },
      },
    });

    this.events.dispatchEvent({
      type: "SOUND_EVENTS",
      message: {
        event_type: "play_sound",
        data: { sndKey: "crowd" },
      },
    });

    this.events.dispatchEvent({
      type: "GAMESCENE_EVENTS",
      message: {
        event_type: "start_game",
        data: {},
      },
    });
  }

  hideScreen() {
    document.querySelector("#start_sec").classList.remove("active");
  }
}
